module.exports = __webpack_public_path__ + "static/media/herramienta-rojo.e0b0a66b.svg";